import { SvgIcon, SvgIconProps } from '@mui/material';

export function FilterIcon(props: SvgIconProps) {
  const defaultColor = '#2C2E30';
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M6.66675 10H13.3334'
        stroke={props.color ?? defaultColor}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5 6.66602H15'
        stroke={props.color ?? defaultColor}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.33325 13.334H11.6666'
        stroke={props.color ?? defaultColor}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </SvgIcon>
  );
}
